import { getAllFiliales } from "api";
import useQuery from "hooks/useQuery";
import queryString from "query-string";
import { useEffect } from "react";
import { showErrorModal } from "utils";

const useGetFiliales = (q, buscar = true) => {
  const { refetch, data } = useQuery({
    autoFetch: false,
    queryFn: getAllFiliales,
    onError: err => showErrorModal({ err }),
  })

  const fetch = (q) => {
    const query = queryString.stringify(q);

    refetch(query);
  };

  useEffect(() => {
    if (!buscar) return;
    fetch(q);
  }, [buscar]);

  const filiales = data?.data?.filiales;
  const filialesOptions = filiales?.map(f => ({
    value: f.id,
    label: f.nombre,
  }))
  
  return {
    filialesOptions,
    filiales,
    refetch,
    fetchFiliales: fetch,
  };
};

export default useGetFiliales;